import { toast as reactHotToast, ToastOptions } from "react-hot-toast";
import { AlertTriangle } from "lucide-react";
import { ReactElement } from "react";

/**
 * Extended toast object with custom toast.info method.
 * toast.success, toast.error, toast.custom, etc. come from react-hot-toast library.
 * This extends the library's toast object with a custom info method.
 * Uses toast.custom, so the Toaster's theme-aware className does not apply: the box sets its own dark variant.
 */
const toastWithInfo = Object.assign(reactHotToast, {
  info: (message: string | ReactElement, options?: ToastOptions) => {
    return toast.custom(
      <div className="flex max-w-xl items-center gap-2 rounded-lg border border-amber-400 bg-amber-100 p-3 dark:border-amber-700 dark:bg-amber-950">
        <div>
          <AlertTriangle className="size-6 text-amber-600 dark:text-amber-400" />
        </div>

        <div className="font-medium text-amber-900 dark:text-amber-100">{message}</div>
      </div>,
      options
    );
  },
});

export const toast = toastWithInfo;
